'use strict';

const ajax = require('./modules/ajax');
const damHelper = require('./dam/dam-helper');
const selectors = {
    SWATCH_BTN: '.js-product-swatches-btn',
    TILE: '.js-product-tile',
    TILE_IMAGE_HOLDER: '.js-product-tile-image',
    TILE_IMAGE: '.js-defered-image',
    TILE_PRODUCT_LINK: '.js-product-name-link',
    OUT_OF_STOCK_BUTTON: '.js-out-of-stock-button',
    OUT_OF_STOCK_WRAP:'.js-out-of-stock-wrap',
    TILE_PERSONALIZE_BUTTON: '.js-btn-tile-personalise',
    CART_BUTTON: '.js-add-to-cart',
    CHILD_IDS: 'input[name="childPids"]',
    USER_ACTIONS: '.js-product-user-actions',
    SWATCHES_LIST: '.js-product-swatches-list',
    RITUALS_FORM: '.rituals-form',
    VARIATION_SWATCHES: '.js-variation-swatches',
    TILE_TITLE : '.js-product-name'
};

const classes = {
    SELECTED: 'selected',
    HIDE: 'hide',
    HIDE_AND_DISABLED: 'hide btn--disabled',
    FORM_WIDE: 'form-wide',
};

const bundleVariationSwatches = {
    init: initEvents
};

function initEvents() {
    $(document).on('click', selectors.SWATCH_BTN, function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $parent = $(this).parent();
        if ($parent.hasClass(classes.SELECTED)) {
            return;
        }

        $parent.siblings().removeClass(classes.SELECTED);
        $parent.addClass(classes.SELECTED);

        updateTileValues($(this));
    });
}

function updateTileValues($swatch){
    const data = JSON.parse($swatch.attr('data'));
    const $tileholder = $swatch.closest(selectors.TILE);
    $tileholder.attr('data-href', data.url);

    updateTileImageAttributes($tileholder, data);
    updateTileHeadingAttributes($tileholder, data);
    updateTileDescriptionAttributes($tileholder, data);
    updateCartButton($tileholder, data);
    updateSocialCommerceElement($tileholder, data);
}

function updateSocialCommerceElement(tileElement, data) {
    const $socialCommerceButton = $('.js-social-commerce-button', tileElement);
    if (!$socialCommerceButton || !$socialCommerceButton.length) {
        return;
    }

    const socialCommerceData = $socialCommerceButton.data('social-commerce');
    if (!socialCommerceData) {
        return;
    }

    let shouldHideSocialCommerceButton = false;

    if ($(selectors.SWATCHES_LIST + selectors.VARIATION_SWATCHES , tileElement).length) {
        shouldHideSocialCommerceButton = !data.isAvailable;
    } else {
        socialCommerceData.configurationId = data.configurationId;
        shouldHideSocialCommerceButton = shouldHideSocialCommerceButton || data.cartButtonAttributes.text;
    }

    $socialCommerceButton.data('social-commerce', socialCommerceData);

    if (shouldHideSocialCommerceButton) {
        $socialCommerceButton.parent().addClass('hide');
        return;
    }

    $socialCommerceButton.parent().removeClass('hide');
}

function updateTileImageAttributes(tileElement, data) {
    const $imageholder = $(tileElement).find(selectors.TILE_IMAGE_HOLDER);
    $imageholder.attr('href', data.url);
    $imageholder.attr('title', data.image.title);

    const $image = $('img', $imageholder);
    $image.css('max-width', data.image.maxWidth);
    $image.attr('data-src', data.image.src);
    $image.attr('src', data.image.src);
    $image.attr('alt', data.image.alt);
    damHelper.updateImages($imageholder);
}

function updateTileHeadingAttributes(tileElement, data) {
    const $productName = tileElement.find(selectors.TILE_PRODUCT_LINK);
    $productName.attr('href', data.url);
}

function updateTileDescriptionAttributes(tileElement, data) {
    if (data.description){
        const $description = tileElement.find('.short-description');
        $description.text(data.description);
    }

    const $showMoreLink = tileElement.find('read-more-link');

    if ($showMoreLink.length > 0) {
        $showMoreLink.attr('href', data.url);
    }
}

function updateCartButton(tileElement, data) {
    const nonBundleSwatches = $(selectors.SWATCHES_LIST + selectors.VARIATION_SWATCHES , tileElement);
    if (nonBundleSwatches.length) {
        const $updateTarget = $(selectors.RITUALS_FORM, tileElement);
        ajax.load({
            url: data.addToCartUrl,
            target: $updateTarget,
            replaceTarget: false,
        });
        return;
    }

    $(selectors.CHILD_IDS, tileElement).val(data.cartButtonAttributes.childIds);
    $('.js-product-configurator-trigger', tileElement).data('product-configuration', JSON.parse(data.cartButtonAttributes.dataProductConfiguration));

    if (data.cartButtonAttributes.text) {
        $(selectors.OUT_OF_STOCK_BUTTON, tileElement).text(data.cartButtonAttributes.text);
        disableCartButton(tileElement);
        return;
    }
    enableCartButton(tileElement);
}

function disableCartButton(tileElement) {
    $(selectors.OUT_OF_STOCK_WRAP + '.hide', tileElement).removeClass(classes.HIDE);
    $(selectors.TILE_PERSONALIZE_BUTTON, tileElement).addClass(classes.HIDE);
    $(selectors.CART_BUTTON, tileElement).addClass(classes.HIDE_AND_DISABLED);
    $(selectors.USER_ACTIONS, tileElement).addClass(classes.FORM_WIDE);
}

function enableCartButton(tileElement) {
    $(selectors.OUT_OF_STOCK_WRAP, tileElement).addClass(classes.HIDE);
    $(selectors.TILE_PERSONALIZE_BUTTON + '.hide', tileElement).removeClass(classes.HIDE);
    $(selectors.CART_BUTTON + '.hide', tileElement).removeClass(classes.HIDE_AND_DISABLED);
    $(selectors.USER_ACTIONS, tileElement).removeClass(classes.FORM_WIDE);
}

module.exports = bundleVariationSwatches;
